/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {confirmPayment} from '../api'

export const useMutationConfirmPayment = createReactQueryMutationHook('confirmPayment', confirmPayment)
